module.exports = __webpack_public_path__ + "img/9791187336655.149af83b.jpg";